// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1jZXt","sendOtp":"AuthorizeToLogin_sendOtp__1ATN5"};